// Enums that defined allowed values for setting configuration

/**
 * Allowed values for the 'OwnedAugmentationsOrder' setting
 */
export enum PurchaseAugmentationsOrderSetting {
  Cost,
  Default,
  Reputation,
  Purchasable,
}

/**
 * Allowed values for the 'OwnedAugmentationsOrder' setting
 */
export enum OwnedAugmentationsOrderSetting {
  Alphabetically,
  AcquirementTime,
}
